/**
 * 必須項目: 未入力時はピンク背景クラスを付与（Form.css の .app-required-input--empty）
 */
export function requiredFieldClass(value, required = true) {
    const base = 'form-control';
    if (!required) return base;
    const empty =
        value === undefined ||
        value === null ||
        (typeof value === 'string' && value.trim() === '');
    return `${base} app-required-input${empty ? ' app-required-input--empty' : ''}`;
}

/** select 用（form-select クラス） */
export function requiredSelectClass(value, required = true) {
    const base = 'form-select';
    if (!required) return base;
    const empty =
        value === undefined ||
        value === null ||
        (typeof value === 'string' && value.trim() === '');
    return `${base} app-required-input${empty ? ' app-required-input--empty' : ''}`;
}

/** ファイル未選択時のラッパー用クラス名 */
export function requiredFileWrapClass(hasFile, required = true) {
    if (!required) return 'app-required-file-wrap';
    return `app-required-file-wrap${!hasFile ? ' app-required-file-wrap--empty' : ''}`;
}
